import React, { useState, useEffect } from "react";
function MonthlyAttendence() {
  const [selectedMonth, setSelectedMonth] = useState("");
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  useEffect(() => {
    const today = new Date();
    const month = today.toISOString().slice(0, 7); // YYYY-MM
    setSelectedMonth(month);
  }, []);

  // ✅ Get number of days dynamically
  const getDaysInMonth = monthStr => {
    if (!monthStr) return 31;
    const [year, month] = monthStr.split("-");
    return new Date(year, month, 0).getDate(); // MAGIC
  };
  const daysInMonth = getDaysInMonth(selectedMonth);
  const days = Array.from({
    length: daysInMonth
  }, (_, i) => i + 1);
  const getMonthName = monthStr => {
    if (!monthStr) return "";
    const date = new Date(monthStr + "-01");
    return date.toLocaleString("default", {
      month: "long",
      year: "numeric"
    });
  };
  const getColor = val => {
    if (val === "P") return "text-success fw-bold";
    if (val === "A") return "text-danger fw-bold";
    if (val === "H") return "text-primary fw-bold";
    if (val === "L") return "text-warning fw-bold";
    return "";
  };
  useEffect(() => {
    if (!selectedMonth) return;
    const fetchAttendance = async () => {
      try {
        setLoading(true);
        const res = await fetch(`https://api.sweepydo.in/fetch-attendance-monthly?month=${selectedMonth}`);
        const result = await res.json();
        // console.log(result,'result');
        setData(result);
      } catch (error) {
        console.error("Error fetching attendance:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchAttendance();
  }, [selectedMonth]);
  const calculateSummary = (attendance, totalDays) => {
    let P = 0,
      A = 0,
      L = 0;
    for (let i = 1; i <= totalDays; i++) {
      const val = attendance?.[i];
      if (val === "Present") P++;else if (val === "Leave") L++;else A++; // default absent (VERY IMPORTANT)
    }
    return {
      P,
      A,
      L
    };
  };
  const filteredData = data.filter(emp => emp.name.toLowerCase().includes(search.toLowerCase()));
  return <div className="container-fluid mt-2 p-3  rounded">

      {/* Header */}
      <h4 className="text-center mb-4 text-white">Attendance Report</h4>
{loading && <div className="text-center mb-2 text-white">
    Loading attendance...
  </div>}
   
     <div className="Card shadow-sm border-0">


  <div className="card-header d-flex justify-content-between align-items-center" style={{
        backgroundColor: "var(--black2)",
        color: "#fff"
      }}>
 
  </div>

  {/* Card Body */}
  <div className="card-body">

    {/* Filters Row */}
    <div className="row mb-3">
      <div className="col-md-4">
        <label className="form-label text-white">Search:</label>
        <input type="text" className="form-control" placeholder="Search..." value={search} onChange={e => setSearch(e.target.value)} />
      </div>

      <div className="col-md-4">
        <label className="form-label text-white">Select Month:</label>
        <input type="month" className="form-control" value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} />
      </div>

      <div className="col-md-4 d-flex align-items-end justify-content-end gap-3">
        <span className="text-success">P - Present</span>
        <span className="text-danger">A - Absent</span>
        <span className="text-warning">L - Leave</span>
      </div>
    </div>

    {/* Title */}
    <div className="p-2 rounded text-center mb-3" style={{
          backgroundColor: "var(--black)",
          color: "#fff"
        }}>
      <h6 className="mb-0 text-info">
        Attendance for: {getMonthName(selectedMonth)}
      </h6>
    </div>




    <div className="table-responsive">
  <table className="table table-bordered text-center align-middle">
    <thead>
      <tr>
        <th style={{
                  backgroundColor: "var(--black2)",
                  color: "#fff"
                }}>SN</th>
        <th style={{
                  backgroundColor: "var(--black2)",
                  color: "#fff"
                }}>Emp Name</th>
        <th style={{
                  backgroundColor: "var(--black2)",
                  color: "#fff"
                }}>P</th>
        <th style={{
                  backgroundColor: "var(--black2)",
                  color: "#fff"
                }}>A</th>
        <th style={{
                  backgroundColor: "var(--black2)",
                  color: "#fff"
                }}>L</th>

        {days.map(day => <th key={day} style={{
                  backgroundColor: "var(--black2)",
                  color: "#fff"
                }}>
            {day}
          </th>)}
      </tr>
    </thead>

    <tbody>
      {filteredData.map((emp, index) => {
                // ✅ Calculate Summary
                let P = 0,
                  A = 0,
                  L = 0;
                for (let i = 1; i <= days.length; i++) {
                  const val = emp.attendance?.[i];
                  if (val === "Present") P++;else if (val === "Leave") L++;else A++; // default absent
                }
                return <tr key={index}>
            <td style={{
                    backgroundColor: "var(--black)",
                    color: "#fff"
                  }}>
              {index + 1}
            </td>

            <td className="text-start" style={{
                    backgroundColor: "var(--black)",
                    color: "#fff"
                  }}>
              {emp.name}
            </td>

            {/* ✅ Summary */}
            <td className="text-success" style={{
                    backgroundColor: "var(--black)",
                    color: "#fff"
                  }}>
              {P}
            </td>
            <td className="text-danger" style={{
                    backgroundColor: "var(--black)",
                    color: "#fff"
                  }}>
              {A}
            </td>
            <td className="text-warning" style={{
                    backgroundColor: "var(--black)",
                    color: "#fff"
                  }}>
              {L}
            </td>

            {/* ✅ Day-wise Attendance */}
            {days.map(day => {
                    const val = emp.attendance?.[day];
                    const short = val === "Present" ? "P" : val === "Absent" ? "A" : val === "Leave" ? "L" : "";
                    const color = val === "Present" ? "text-success fw-bold" : val === "Absent" ? "text-danger fw-bold" : val === "Leave" ? "text-warning fw-bold" : "";
                    return <td key={day} className={color} style={{
                      backgroundColor: "var(--black)",
                      color: "#fff"
                    }}>
                  {short}
                </td>;
                  })}
          </tr>;
              })}
    </tbody>
  </table>
</div>

  </div>
</div>


    </div>;
}
export default MonthlyAttendence;
